import { COLORS } from '../utils/colors';
import { siteContent } from '../content';
import { LogoWithText } from './Logo';

export const Footer = () => (
  <footer className="py-12 px-6 lg:px-20" style={{ backgroundColor: '#F8FAFC', borderTop: '1px solid #E2E8F0' }}>
    <div className="max-w-6xl mx-auto">
      <div className="grid md:grid-cols-3 gap-8 mb-8">
        <div>
          <div className="mb-4">
            <LogoWithText dark={false} />
          </div>
          <p className="text-sm" style={{ color: COLORS.slate }}>
            {siteContent.company.location}
          </p>
        </div>
        <div>
          <h4 className="text-lg font-semibold mb-4" style={{ color: COLORS.navy }}>Contact</h4>
          <div className="space-y-2" style={{ color: COLORS.slate }}>
            <div>📧 {siteContent.company.email}</div>
            {siteContent.company.calendly && <div>📅 Schedule a call</div>}
            {siteContent.company.linkedin && <div>💼 LinkedIn</div>}
          </div>
        </div>
        <div>
          <h4 className="text-lg font-semibold mb-4" style={{ color: COLORS.navy }}>Legal</h4>
          <div className="space-y-2" style={{ color: COLORS.slate }}>
            <div>ABN: {siteContent.company.abn}</div>
            <div>Privacy Policy</div>
            <div>Terms of Service</div>
          </div>
        </div>
      </div>
      <div className="pt-8 text-center" style={{ borderTop: '1px solid #E2E8F0', color: COLORS.slate }}>
        <p>&copy; {siteContent.company.displayName} 2025 – Executive IT Strategy & CIO Advisory</p>
      </div>
    </div>
  </footer>
);
